import React from 'react';
import { LoginButton } from '@olo-web/components/atoms/LoginButton';
import { BasicHeaderLayout } from '@olo-web/components/atoms/BasicHeaderLayout';
import { VStack, Button, Icon, HStack } from '@chakra-ui/react';
import { ArrowLeft } from 'react-feather';
import { BasicHeaderLogoOrName } from '@olo-web/components/atoms/BasicHeaderLogoOrName';
import { useCustomer } from '@olo-web/domain/customer';
import {
  useIsScanAndPayPage,
  useIsLevelup,
  useIsDineIn,
  useIsCheckoutOptionsPage,
} from '@olo-web/utils/common/hooks';
import { useIsSplitByAmount } from '@olo-web/utils/common/hooks/useIsSplitByAmount';
import { DisruptionIconButton } from '@olo-web/components/molecules/DisruptionIconButton/DisruptionIconButton';

export const CheckoutNavBar = () => {
  const { data: customer } = useCustomer();
  const isScanAndPayPage = useIsScanAndPayPage();
  const isLevelup = useIsLevelup();
  const isDineIn = useIsDineIn();
  const isCheckoutOptionsPage = useIsCheckoutOptionsPage();
  const isSplitByAmount = useIsSplitByAmount();

  if (isDineIn) {
    return (
      <BasicHeaderLayout data-testid="checkout-nav-bar">
        <VStack w="33%" alignItems="baseline">
          <VStack pl="2">
            {!isSplitByAmount && (
              <Button
                variant="tertiary"
                colorScheme="black"
                alignItems="center"
                justifyContent="space-between"
                p={0}
                onClick={() => window.history.go(-1)}
                data-testid="back-button"
              >
                <Icon as={ArrowLeft} h={4} w={4} strokeWidth={2} marginRight={1} />
                Back
              </Button>
            )}
          </VStack>
        </VStack>
        <VStack w="33%">
          <BasicHeaderLogoOrName isLogoClickable={!(isScanAndPayPage || isDineIn)} />
        </VStack>
        <HStack w="33%" justifyContent="flex-end">
          <DisruptionIconButton />
          {!customer?.customerId && !isCheckoutOptionsPage && (
            <LoginButton pr={3} marginInlineStart="0!important" data-testid="login-button" />
          )}
        </HStack>
      </BasicHeaderLayout>
    );
  }
  return (
    <BasicHeaderLayout data-testid="checkout-nav-bar">
      <BasicHeaderLogoOrName isLogoClickable={!isScanAndPayPage} />
      <HStack>
        <DisruptionIconButton />
        {!isLevelup && !customer?.customerId && (
          <LoginButton paddingRight="8px" marginLeft="0px !important" data-testid="login-button" />
        )}
      </HStack>
    </BasicHeaderLayout>
  );
};
